/**
 * smooth scroll js
 */

 var component_smooth_scroll = function() {

  var scroll = new SmoothScroll('a[href*="#"]', {
    speed: 300
  });

  // make the call chainable
  return this;


};
